import React from "react";
import { motion } from "framer-motion";
import { BookOpen, ExternalLink } from "lucide-react";
import MotionButton from "./motion/MotionButton";

export const BOOK_URL = "https://amzn.eu/d/0dWHOTMI";

/**
 * Reusable "Buy the book on Amazon" CTA. Shown after exam/SSM sessions
 * when the user scores below the pass threshold.
 */
export default function BookCTA({
  title = "Sotto il 70%? Studia con il manuale ufficiale.",
  eyebrow = "// Hai bisogno di rinforzo",
  description = (
    <>
      Per superare l'esame di abilitazione italiano serve preparazione strutturata.
      Il manuale di teoria di{" "}
      <span className="text-brand-primary font-medium">Medicos para Italia</span> ti
      guida specialità per specialità, con casi clinici reali e linee guida aggiornate.
    </>
  ),
}) {
  return (
    <motion.div
      data-testid="book-cta-card"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.3 }}
      className="border border-brand-red/40 bg-gradient-to-br from-brand-red/8 via-brand-surface to-brand-green/8 rounded-2xl p-6 sm:p-8"
    >
      <div className="flex items-start gap-4">
        <div className="h-12 w-12 rounded-xl bg-brand-red/15 text-brand-red flex items-center justify-center shrink-0">
          <BookOpen className="h-6 w-6" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="eyebrow text-brand-red mb-2">{eyebrow}</div>
          <h3 className="heading-display text-2xl sm:text-3xl text-brand-primary">
            {title}
          </h3>
          <p className="mt-3 text-base text-brand-secondary leading-relaxed">
            {description}
          </p>
          <a href={BOOK_URL} target="_blank" rel="noopener noreferrer" data-testid="book-cta-link">
            <MotionButton variant="red" className="mt-5">
              <BookOpen className="h-4 w-4" />
              Acquista il libro su Amazon
              <ExternalLink className="h-3.5 w-3.5 opacity-80" />
            </MotionButton>
          </a>
        </div>
      </div>
    </motion.div>
  );
}
